<div class="p-6 pb-3">

  <!-- Mobile tab selector and actions -->
  <div class="sm:hidden">
    <div class="grid grid-cols-1 mb-4">
      <select
        [(ngModel)]="activeTab"
        (change)="setActiveTab(activeTab)"
        aria-label="Select a tab"
        class="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-2 pr-8 pl-3 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-primary">
        <option *ngFor="let tab of tabs" [value]="tab.id">{{ tab.label }}</option>
      </select>
      <svg viewBox="0 0 16 16" fill="currentColor" data-slot="icon" aria-hidden="true" class="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end fill-gray-500">
        <path d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" fill-rule="evenodd" />
      </svg>
    </div>
    <!-- Mobile actions -->
    <div class="flex items-center justify-end space-x-2">
      <button type="button" (click)="handleSearch()" class="p-2 bg-gray-50 rounded-md">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-5 w-5">
          <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
        </svg>
      </button>
      <button type="button" (click)="handleAddNew()" class="inline-flex items-center gap-x-1.5 rounded-md bg-primary px-2.5 py-2 text-sm font-medium text-white shadow-xs hover:opacity-90">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="-ml-0.5 size-5">
          <path d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
        </svg>
        Add New
      </button>
    </div>
  </div>

  <!-- Desktop tabs and actions -->
  <div class="hidden sm:flex sm:items-center sm:justify-between">
    <!-- Tabs -->
    <nav aria-label="Tabs" class="flex space-x-4">
      <a
        *ngFor="let tab of tabs"
        (click)="setActiveTab(tab.id)"
        [class]="getTabClass(tab.id)"
        [attr.aria-current]="activeTab === tab.id ? 'page' : null"
        class="cursor-pointer rounded-md px-3 py-2 text-sm font-medium transition-colors">
        {{ tab.label }}
      </a>
    </nav>

    <!-- Actions -->
    <div class="flex items-center space-x-3">
      <!-- Search -->
      <div class="relative rounded-md">
        <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-5 w-5 text-secondary">
            <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
          </svg>
        </div>
        <input
          type="text"
          name="search_query"
          id="search_query"
          [(ngModel)]="searchQuery"
          (keyup.enter)="handleSearch()"
          autocomplete="off"
          class="block w-full rounded-md border-0 py-1.5 pl-10 text-secondary ring-1 ring-inset ring-gray-100 dark:ring-[#3b4377] placeholder:text-secondary/50 placeholder:font-poppins placeholder:tracking-wide focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
          [placeholder]="getSearchPlaceholder()">
      </div>

      <!-- Search Button -->
      <button type="button" (click)="handleSearch()" class="btn bg-gray-50 dark:bg-primary-200 text-secondary text-sm hover:opacity-90">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-5 w-5">
          <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
        </svg>
      </button>

      <!-- Add New -->
      <button type="button" (click)="handleAddNew()" class="inline-flex items-center gap-x-1.5 rounded-md bg-primary px-2.5 py-2 text-sm font-medium text-white shadow-xs hover:opacity-90 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="-ml-0.5 size-5">
          <path d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
        </svg>
        {{ getAddButtonText() }}
      </button>
    </div>
  </div>

  <!-- Tab content -->
  <div class="mt-6">

    <div [style.display]="activeTab === 'contacts' ? 'block' : 'none'">
      <app-contacts [searchQuery]="searchQuery" (searchQueryChange)="searchQuery = $event"></app-contacts>
    </div>

    <div [style.display]="activeTab === 'companies' ? 'block' : 'none'">
      <app-companies [searchQuery]="searchQuery" (searchQueryChange)="searchQuery = $event"></app-companies>
    </div>

    <div [style.display]="activeTab === 'deals' ? 'block' : 'none'">
      <app-deals [searchQuery]="searchQuery" (searchQueryChange)="searchQuery = $event"></app-deals>
    </div>

  </div>
</div>
